import React, { useEffect, useMemo, useState } from 'react';

import { Tooltip, Select } from 'antd';
import { Link } from 'react-router-dom';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useGetSeveritiesQuery } from 'src/redux/services/centralApi';
import { FormItem, FormLabel } from 'src/pages/observers/components/styles';
import type {
	ISeveritySelectComponent
} from 'src/pages/observers/components/SeveritySelect/types';
import {
	OptionRenderContainer,
	SeverityColor
} from 'src/pages/observers/components/SeveritySelect/styles';

export default function SeveritySelect(
	{
		defaultSeverity,
		onSeverityChange,
	}: ISeveritySelectComponent
) {
	const {
		data: severitiesData,
		isLoading: isLoadingSeverities,
	} = useGetSeveritiesQuery();

	const [ severity, setSeverity, ] = useState<string | undefined>(defaultSeverity);

	const severitiesOptions = useMemo(() => {
		if (!severitiesData) return [];

		return severitiesData.flatMap((severity) => {
			if(!severity.is_active) return [];

			return {
				label: severity.name,
				value: severity.severity_id,
				color: severity.color,
			};
		});
	}, [ severitiesData, ]);

	useEffect(() => {
		if(severity && onSeverityChange)
			onSeverityChange(severity);
	}, [ severity, ]);

	return (
		<FormItem>
			<FormLabel>
                * Severidade:
				{severitiesOptions.length === 0 && (
					<Tooltip
						title={
							<>
								{'Configure uma periodicidade '}
								<Link
									to={`${process.env.REACT_APP_PUBLIC_URL}/cron/adicionar`}
								>
                                    aqui
								</Link>
								{' para ter acesso a essa funcionalidade.'}
							</>
						}
					>
						<QuestionCircleOutlined
							style={{
								color: 'rgba(0,0,0,0.45)',
								cursor: 'help',
							}}
						/>
					</Tooltip>
				)}
			</FormLabel>
			<Select
				placeholder='Severidade'
				value={severity}
				onChange={(value) => setSeverity(value)}
				options={severitiesOptions}
				loading={isLoadingSeverities}
				disabled={severitiesOptions.length === 0}
				optionRender={(option) => (
					<OptionRenderContainer>
						<SeverityColor
							style={{
								backgroundColor: option.data.color,
							}}
						/>
						{option.label}
					</OptionRenderContainer>
				)}
			/>
		</FormItem>
	);
}
